export default {
      id: "ic_first_user-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_first_user-usage",
      toString: function () {
        return this.url;
      }
    }